import React from 'react';
import SectionHeader from './SectionHeader';
import NotesInput from './NotesInput';

const OPTIONS = [
  { value: 'annually', label: 'Annually' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'daily', label: 'Daily' },
];

/**
 * Section 7 — Portfolio Monitoring frequency (multiple choice).
 */
export default function StepPortfolioMonitoring({ data, onChange }) {
  function update(field, value) {
    onChange({ ...(data || {}), [field]: value });
  }

  return (
    <div>
      <SectionHeader
        number={7}
        title="How often are you currently checking your portfolio?"
        tip="Annually, quarterly, monthly, etc…"
        showAnnualNote={false}
      />
      <div className="cashflow-section-card">
        <label className="form-label d-block mb-3">
          Select one <span className="text-danger">*</span>
        </label>
        <div className="d-grid gap-2">
          {OPTIONS.map((option) => (
            <label
              key={option.value}
              className={`form-check portfolio-choice ${data?.check_frequency === option.value ? 'portfolio-choice--active' : ''}`}
            >
              <input
                className="form-check-input portfolio-choice-input"
                type="radio"
                name="check_frequency"
                checked={data?.check_frequency === option.value}
                onChange={() => update('check_frequency', option.value)}
              />
              <span className="portfolio-choice-label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => update('notes', val)}
        label="Do you have any concerns or questions your advisor should prepare to address?"
        placeholder="Share any concerns or questions for your advisor (optional)."
      />
    </div>
  );
}
